import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { AuthContext } from './auth.types';

export const AUTH_API_URL = new InjectionToken<string>('AUTH_API_URL');
export const AUTH_CONTEXT = new InjectionToken<AuthContext>('AUTH_CONTEXT');
export const AUTH_LOGIN_URL = new InjectionToken<string>('AUTH_LOGIN_URL');
export const SKIP_ACCESS_TOKEN = new HttpContextToken<boolean>(() => false);
/** Evita un segundo refresh si el reintento tras 401 vuelve a fallar. */
export const AUTH_RENEW_RETRY = new HttpContextToken<boolean>(() => false);

export function resolveAuthApiUrl(configuredUrl: string): string {
  const normalized = configuredUrl.replace(/\/+$/, '');
  return normalized.endsWith('/api/auth')
    ? normalized
    : `${normalized}/api/auth`;
}

export function buildPortalUrl(
  portal: { url: string; defaultPath: string },
  useLocalUrl?: string,
): string {
  if (useLocalUrl) {
    return useLocalUrl;
  }

  const base = portal.url.replace(/\/+$/, '');
  const path = portal.defaultPath
    ? `/${portal.defaultPath.replace(/^\/+/, '')}`
    : '';
  return `${base}${path}`;
}

/** Transporta el estado del menú entre apps y lo deja en la URL de destino. */
export function withSidebarCollapsed(url: string, collapsed: boolean): string {
  const target = new URL(url);
  target.searchParams.set('sidebarCollapsed', String(collapsed));
  return target.toString();
}

export function portalCodeToAppId(code: string): string {
  return code === 'SETTINGS' ? 'admin' : code.toLowerCase().replace('_', '-');
}
